// Système de filtrage Ajax pour les collections
class CollectionFilters {
  constructor() {
    this.container = document.querySelector('#product-grid');
    this.filterForm = document.querySelector('[data-ref="filters-form"]');
    this.sortingSelects = document.querySelectorAll('[data-ref="sorting-select"], [data-ref="sorting-list"]');
    
    if (this.filterForm) {
      this.init();
    }
  }

  init() {
    // Intercepter les changements de filtres
    this.filterForm.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox' || e.target.name.includes('filter.v.price')) {
        this.applyFilters();
      }
    });

    // Intercepter les clics sur "Effacer tout"
    const clearButtons = document.querySelectorAll('.filters__clear-all a, .filter-clear-button');
    clearButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        window.location.href = button.href;
      });
    });

    // Intercepter le tri
    this.sortingSelects.forEach(select => {
      if (select.tagName === 'SELECT') {
        select.addEventListener('change', () => {
          this.applyFilters();
        });
      } else if (select.classList.contains('sorting__list')) {
        const items = select.querySelectorAll('.sorting__select');
        items.forEach(item => {
          item.addEventListener('click', () => {
            const sortValue = item.dataset.value;
            const hiddenInput = document.querySelector('input[name="sort-by"]');
            if (hiddenInput) {
              hiddenInput.value = sortValue;
            }
            this.applyFilters();
          });
        });
      }
    });
  }

  applyFilters() {
    // Construire l'URL avec les filtres
    const formData = new FormData(this.filterForm);
    const searchParams = new URLSearchParams();

    // Ajouter tous les paramètres de filtre
    for (let [key, value] of formData.entries()) {
      if (value) {
        searchParams.append(key, value);
      }
    }

    // Ajouter le tri
    const sortSelect = document.querySelector('select[name="sort-by"]');
    const sortInput = document.querySelector('input[name="sort-by"]');
    const sortValue = sortSelect ? sortSelect.value : (sortInput ? sortInput.value : '');
    
    if (sortValue && sortValue !== 'manual') {
      searchParams.append('sort_by', sortValue);
    }

    // Construire la nouvelle URL
    const baseUrl = window.location.pathname;
    const newUrl = searchParams.toString() ? `${baseUrl}?${searchParams.toString()}` : baseUrl;

    // Charger les produits filtrés
    this.loadFilteredProducts(newUrl);
    
    // Mettre à jour l'URL du navigateur sans recharger
    window.history.pushState({}, '', newUrl);
  }

  async loadFilteredProducts(url) {
    try {
      // Ajouter un indicateur de chargement
      if (this.container) {
        this.container.style.opacity = '0.5';
        this.container.style.pointerEvents = 'none';
      }

      // Charger la page filtrée
      const response = await fetch(url);
      const html = await response.text();
      
      // Parser le HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      // Extraire la grille de produits
      const newGrid = doc.querySelector('.main-collection__products-grid');
      const currentGrid = document.querySelector('.main-collection__products-grid');
      
      if (newGrid && currentGrid) {
        // Remplacer le contenu
        currentGrid.innerHTML = newGrid.innerHTML;
        
        // Réinitialiser les sliders (Splide)
        this.reinitSliders();
      }

      // Retirer l'indicateur de chargement
      if (this.container) {
        this.container.style.opacity = '1';
        this.container.style.pointerEvents = 'auto';
      }

      // Scroll vers le haut de la grille
      this.container.scrollIntoView({ behavior: 'smooth', block: 'start' });

    } catch (error) {
      console.error('Erreur lors du chargement des produits:', error);
      // En cas d'erreur, recharger la page normalement
      window.location.href = url;
    }
  }

  reinitSliders() {
    // Réinitialiser les sliders Splide si nécessaire
    const sliders = document.querySelectorAll('.main-collection__products-grid slider-component');
    sliders.forEach(slider => {
      // Le custom element devrait se réinitialiser automatiquement
      if (slider.connectedCallback) {
        slider.connectedCallback();
      }
    });
  }
}

// Initialiser au chargement de la page
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionFilters();
  });
} else {
  new CollectionFilters();
}